/**
 * Question Type Constants
 * Item.questionType values, exactly as stored in the database (case-sensitive).
 * Keep in sync with server/src/Constants/QuestionTypeConstants.php.
 */

export const QUESTION_TYPES = {
  SCALE: "Scale",
  CUSTOM_SCALE: "Custom scale",
  FORCED_CHOICE: "Forced choice",
  FORCED_CHOICE_NEW: "Forced choice new",
  MULTIPLE_2_CHOICE: "Multiple 2 choice",
  MULTIPLE_2_CHOICE_NEW: "Multiple 2 choice new",
  DROPDOWN: "Dropdown",
  RADIO_BUTTON: "Radio button",
  OPEN_QUESTION: "Open question",
  MULTIPLE_OPEN: "Multiple open",
  LEVEL_BASED_OPEN_QUESTION: "Level Based Open Question",
  INTRODUCTION: "Introduction",
};
